import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/entity-relate/`;

class cdoEntityRelate {
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }

    replaceOwner = (data, callback) => {
        util.putJSON(servicesURL + 'replace-owner', data, callback);
    }

    replace = (data, callback) => {
        util.putJSON(servicesURL + 'replace', data, callback);
    }

    upsertScore = (data, callback) => {
        util.putJSON(servicesURL + 'upsert-score', data, callback);
    }

    adjustScore = (data, callback) => {
        util.putJSON(servicesURL + 'adjust-score', data, callback);
    }

    selectOwner = (idRelated, callback) => {
        util.getJSON(`${servicesURL}owner?idRelated=${encodeURIComponent(idRelated)}`, callback);
    }

    selectRelated = (idRelated, relateType, callback) => {
        util.getJSON(
            `${servicesURL}related?idRelated=${encodeURIComponent(idRelated)}&relateType=${encodeURIComponent(relateType)}`,
            callback
        );
    }

    selectByEntity = (idEntity, relateType, callback) => {
        util.getJSON(
            `${servicesURL}entity?idEntity=${encodeURIComponent(idEntity)}&relateType=${encodeURIComponent(relateType)}`,
            callback
        );
    }

    selectRapport = (idA, idB, callback) => {
        util.getJSON(
            `${servicesURL}rapport?idA=${encodeURIComponent(idA)}&idB=${encodeURIComponent(idB)}`,
            callback
        );
    }
}

const cdo = new cdoEntityRelate();
export default cdo;
